import { useKrakenQuery } from '@/components/GraphQLClient';
import ServiceablePropertiesLookup from '@/hooks/moveHome/useServiceablePropertiesLookup/ServiceablePropertiesLookup.graphql';
import { serviceablePropertiesLookupSchema } from '@/hooks/moveHome/validations';
import { FoundAddress, UseAddressLookupParams } from '@/pages/move-home/types';

export const useServiceablePropertiesLookup = ({
  postcode,
}: UseAddressLookupParams) => {
  return useKrakenQuery<
    { serviceableProperties: { edges: FoundAddress[] } },
    Error,
    FoundAddress[]
  >({
    queryKey: ['serviceablePropertiesLookup'],
    query: ServiceablePropertiesLookup,
    select: (data) => data.serviceableProperties.edges,
    validateFn(response) {
      return serviceablePropertiesLookupSchema.validate(response);
    },
    enabled: false,
    variables: { postcode },
  });
};
